import { Navigate, useLocation } from "react-router-dom";

export default function FacilitiesJobsPage() {
  const location = useLocation();
  return <Navigate to={`${location.pathname}/all-jobs`} replace />;
}
